﻿export default function apartmentsCount (value, onlyWords = false) {
    const postfixes = ['', 'а', 'ы', 'ы', 'ы', '', '', '', '', ''];
    const lastDigits = value % 100;
    if (lastDigits >= 10 && lastDigits <= 20) {
        return onlyWords ? 'квартир' : `${Math.trunc(value)} квартир`;
    }
    else {
        return onlyWords ? `квартир${postfixes[value % 10]}` : `${Math.trunc(value)} квартир${postfixes[value % 10]}`;
    }
}